import { useContext } from 'react';
import { AuthContext } from '~/contexts/DeviseTokenAuthContext';
import { UserDataJSONAPI } from '~/sections/user-profile/types';
import { useQuery } from 'react-query';
import { show as fetchCurrentUser } from '~/api/scheme/current_user';

type Result = {
  currentUser?: UserDataJSONAPI;
  isMasquerade: boolean;
  isLoading: boolean;
  isError: boolean;
  refetchUser: () => void;
};

const useCurrentUser = (): Result => {
  const {
    data: currentUserData,
    isLoading,
    isError,
    refetch,
  } = useQuery('currentUser', fetchCurrentUser);

  const auth = useContext(AuthContext);

  const currentUser = auth?.user;
  const isMasquerade = auth?.isMasquerade || false;

  return {
    currentUser,
    isMasquerade,
    isLoading,
    isError,
    refetchUser: refetch,
  };
};

export default useCurrentUser;
